import React from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import strings from '../../../localization';

import styles from './styles';

const CounterOfferChip = () =>
  (
    <Box style={styles.counterCard}>
      <Box sx={styles.counterOfferCard}>
        <Typography sx={styles.counterOfferCardText}>
          {strings.counterOffer}
        </Typography>
      </Box>
    </Box>
  );

export default CounterOfferChip;
